export enum MicrositeOption {
	EDIT,
	DUPLICATE
}
